import React, { Dispatch } from 'react';
import { FindImagesTypeFilterGroupView, FindImagesTypeFilterGroupViewProps } from './FindImagesTypeFilterGroup.view';
import { FindImagesFilterAction } from '../../../models/media';

export type FindImagesTypeFilterGroupControllerProps = FindImagesTypeFilterGroupViewProps & {
  dispatchFilters?: Dispatch<FindImagesFilterAction>;
};

export const FindImagesTypeFilterGroupController = (props: FindImagesTypeFilterGroupControllerProps): JSX.Element => {
  const viewProps: FindImagesTypeFilterGroupViewProps = { ...props };
  return <FindImagesTypeFilterGroupView {...viewProps} />;
};
